/** Rendering policy only: never rewrites stored article Markdown. */
export function insightSlugFromHref(href: string): string | null {
  try {
    const url = new URL(href, "https://premierpharma.com");
    if (!["premierpharma.com", "www.premierpharma.com"].includes(url.hostname)) return null;
    const match = /^\/insights\/([^/]+)\/?$/.exec(url.pathname);
    return match ? decodeURIComponent(match[1]).toLowerCase() : null;
  } catch {
    return null;
  }
}

export function canRenderEditorialLink(href: string, publicInsightSlugs: readonly string[] = []): boolean {
  const slug = insightSlugFromHref(href);
  return slug === null || publicInsightSlugs.includes(slug);
}
